<template>
  <div v-if="showSelectedFilters" class="checked-filters__wrapper">
    <div class="checked-filters">
      <ul>
        <li v-for="({ key, value }, index) in redo" :key="index">
          <template v-if="Object.keys(value)[0] === 'price'">
            <button class="button" @click="clearFilter(value)">
              <i class="icon icon-cross" />
              {{ priceFilterLabel(value) }}
            </button>
          </template>
          <template v-else>
            <button class="button" @click="clearFilter(value)">
              <i class="icon icon-cross" />
              {{ getFilterValueLabel(key) }}
            </button>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getFilterValueLabel } from "@/helpers/collection";

export default {
  name: "SelectedFilters",
  props: {
    selectedFilters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["clearFilter", "resetFilters"],
  computed: {
    ...mapGetters("app", ["moneyFormat"]),
    redo() {
      const values = this.selectedFilters
        .filter((item) => Object.keys(item)[0] !== "available")
        .map((item) => {
          const key = Object.keys(item)[0];
          const valueString = item[key].value || Object.values(item)[0];
          if (key) {
            return { key: valueString, value: item };
          }
        });

      return values;
    },
    showSelectedFilters() {
      return this.selectedFilters.length > 0;
    },
  },
  methods: {
    getFilterValueLabel,
    clearFilter(item) {
      this.$emit("clearFilter", item);
    },
    resetFilters() {
      this.$emit("resetFilters");
    },
    formatCurrency(value) {
      return this.moneyFormat.replace("{{amount}}", Math.round(value));
    },
    priceFilterLabel(value) {
      const min = value.price.min;
      const max = value.price.max;

      if (!max) {
        return this.formatCurrency(min) + " and above";
      }
      return this.formatCurrency(min) + " - " + this.formatCurrency(max);
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  border-radius: 4px;
  background-color: $color-grey-light;
  color: $color-black;
  @include utility-label(15px);
  outline: none;
  border: none;
  padding: 8px 12px;
  display: flex;
  align-items: center;

  .icon {
    margin-right: 6px;
  }

  &:hover {
    background-color: $color-black;
    color: $color-white;
  }
}

.checked-filters__wrapper {
  margin: 16px 0;
}

.checked-filters {
  margin-left: -$v-container-padding + 0px;
  margin-right: -$v-container-padding + 0px;
  margin-bottom: 16px;
  overflow-y: auto;
  width: calc(100% + 40px);

  ul {
    padding: 0 $v-container-padding + 0px;
    white-space: nowrap;
    overflow-y: auto;
    display: flex;
    column-gap: 12px;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      flex: 0 0 auto;
      display: inline-block;
    }
  }
}
</style>
